import { formatMoneyString } from '@shared/utils';

export function convertPointsToMoney(points: number): number {
  return points ? Number((points / 10).toFixed(2)) : points;
}

export function convertPointsToMoneyString(points?: number): string | null {
  if (points === undefined) {
    return null;
  }
  const amount: number = points ? Number((points / 10).toFixed(2)) : points;
  return formatMoneyString(amount);
}
